var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentMultiple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.416 15.9368H16.916V15.4368V13.4785V12.9785H16.416H9.56185H9.06185V13.4785V15.4368V15.9368H9.56185H16.416ZM19.3535 12.0202H19.8535V11.5202V9.56185V9.06185H19.3535H9.56185H9.06185V9.56185V11.5202V12.0202H9.56185H19.3535ZM19.3535 8.10352H19.8535V7.60352V5.64518V5.14518H19.3535H9.56185H9.06185V5.64518V7.60352V8.10352H9.56185H19.3535ZM6.57232 18.4264L6.21876 18.7799L6.57232 18.4264C6.29883 18.1529 6.14518 17.782 6.14518 17.3952V3.68685C6.14518 2.87612 6.79278 2.22852 7.60352 2.22852H21.3118C21.6986 2.22852 22.0696 2.38216 22.343 2.65565C22.6165 2.92914 22.7702 3.30007 22.7702 3.68685V17.3952C22.7702 18.2059 22.1226 18.8535 21.3118 18.8535H7.60352C7.21674 18.8535 6.84581 18.6999 6.57232 18.4264ZM2.22852 21.3118V6.14518H3.18685V21.3118V21.8118H3.68685H18.8535V22.7702H3.68685C3.30007 22.7702 2.92914 22.6165 2.65565 22.343C2.38216 22.0696 2.22852 21.6986 2.22852 21.3118Z",
    fill: "#C7C9C7",
    stroke: "#C7C9C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentMultiple);
export default __webpack_public_path__ + "static/media/document_multiple.84c55179.svg";
export { ForwardRef as ReactComponent };